import React from 'react';
import { useAppContext } from '../contexts/AppContext';

const BookReader = () => {
  const {
    bookReaderOpen, setBookReaderOpen,
    bookReaderChapter, setBookReaderChapter,
    bookReaderSource, setBookReaderSource,
    getCollectionStories, getBookStories,
    collections, activeBook, displayName,
    renderStoryContent,
  } = useAppContext();

  if (!bookReaderOpen) return null;
  const readerStories = bookReaderSource
    ? getCollectionStories(bookReaderSource)
    : getBookStories();
  const sourceTitle = bookReaderSource
    ? (collections.find(c => c.id === bookReaderSource)?.name || 'Collection')
    : (activeBook?.title || 'My Stories');

  if (readerStories.length === 0) { setBookReaderOpen(false); return null; }
  const chapter = Math.min(bookReaderChapter, readerStories.length - 1);
  const story = readerStories[chapter];
  if (!story) return null;
  const dateStr = new Date(story.createdAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  const isInterview = story.content && story.content.includes('[Memory Interview');

  return (
    <div className="keepsake-overlay" onClick={() => { setBookReaderOpen(false); setBookReaderChapter(0); setBookReaderSource(null); }}>
      <div className="keepsake-page" onClick={e => e.stopPropagation()}>
        <button className="keepsake-close" onClick={() => { setBookReaderOpen(false); setBookReaderChapter(0); setBookReaderSource(null); }}>×</button>
        <div className="keepsake-corner keepsake-corner--tl" />
        <div className="keepsake-corner keepsake-corner--tr" />
        <div className="keepsake-corner keepsake-corner--bl" />
        <div className="keepsake-corner keepsake-corner--br" />

        <div style={{ textAlign: 'center', marginBottom: '8px', fontFamily: "'Lora', serif", fontSize: '0.82rem', letterSpacing: '3px', textTransform: 'uppercase', color: '#0f172a' }}>
          {sourceTitle}
        </div>
        <div className="keepsake-ornament">✦ ✦ ✦</div>
        <div style={{ textAlign: 'center', marginBottom: '6px', fontFamily: "'Lora', serif", fontSize: '1rem', letterSpacing: '2px', color: '#8a6d3a', textTransform: 'uppercase' }}>
          Chapter {chapter + 1}
        </div>
        <h1 className="keepsake-title">{story.title}</h1>
        <div className="keepsake-meta">{dateStr}</div>
        <div className="keepsake-author">
          {isInterview ? 'A Memory Interview' : `Written by ${displayName || 'the author'}`}
        </div>
        <div className="keepsake-divider" />
        <div className="keepsake-body">
          {renderStoryContent(story.content)}
        </div>
        <div className="keepsake-footer-ornament">— ✦ —</div>

        <div className="book-reader-nav">
          <button disabled={chapter === 0} onClick={() => setBookReaderChapter(chapter - 1)}>← Previous</button>
          <span className="book-reader-progress">{chapter + 1} of {readerStories.length}</span>
          <button disabled={chapter === readerStories.length - 1} onClick={() => setBookReaderChapter(chapter + 1)}>Next →</button>
        </div>
      </div>
    </div>
  );
};

export default BookReader;
